import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import {
  NgxMatInputTelComponent,
  ngxMatInputTelValidator,
} from "ngx-mat-input-tel";
import { BehaviorSubject } from "rxjs";
import { AsyncPipe, JsonPipe } from "@angular/common";

@Component({
    selector: "app-contact-details-form",
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        TranslateModule,
        NgxMatInputTelComponent,
        AsyncPipe,
        JsonPipe,
    ],
    templateUrl: "./contact-details-form.component.html",
    styleUrl: "./contact-details-form.component.scss"
})
export class ContactDetailsFormComponent implements OnInit, OnChanges {
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() formValidity: EventEmitter<any> = new EventEmitter<{
    form: string;
    status: boolean;
  }>();
  @Input() initialValue: any;
  form: FormGroup;
  cdr = inject(ChangeDetectorRef);
  onlyCountries: string[] = [];
  showInput: boolean = false;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      PHONE: ["", [Validators.required, ngxMatInputTelValidator]],
    });
  }

  get phone() {
    return this.form.get("PHONE");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.["initialValue"]) {
      const currentForm = changes?.["initialValue"]?.currentValue;
      const country = currentForm?.COUNTRY?.toLowerCase();
      if (country && !this.onlyCountries.includes(country)) {
        this.showInput = false;
        this.cdr.detectChanges();
        this.setPreferredCountries(currentForm?.COUNTRY);
      }
    }
  }

  ngOnInit() {
    if (this.initialValue?.COUNTRY) {
      this.setPreferredCountries(this.initialValue?.COUNTRY);
    } else {
      this.phone?.disable();
    }
    this.form.patchValue({
      PHONE: this.initialValue?.PHONE || "",
    });
    this.setFormValidity();
    this.form.valueChanges.subscribe((value) => {
      this.setFormValidity();
      this.onChange.emit(value);
    });
  }

  setPreferredCountries(country: string) {
    const currentCountry = this.onlyCountries?.[0];
    const newCountry = String(country)?.toLowerCase();
    this.onlyCountries = [newCountry];

    if (currentCountry !== newCountry) {
      this.phone?.setValue("");
      this.phone?.markAsUntouched();
    }

    this.showInput = true;
    this.cdr.detectChanges();

    if (this.phone?.disabled) {
      this.phone?.enable();
    }
  }

  setFormValidity() {
    this.formValidity.emit({ form: "contact", status: this.form.valid });
  }
}
